// extracted by mini-css-extract-plugin
export default {"title":"index_title_mASCk","cut":"index_cut_UqiGo","title_l":"index_title_l_vtD-l","middle":"index_middle_TmRGz","title_r":"index_title_r_XbsQA"};